import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./transaction_state.js";
//#region src/transaction_state_helper.ts
var transaction_state_helper_exports = /* @__PURE__ */ __exportAll({ stringFromEnum: () => stringFromEnum });
function stringFromEnum(state) {
	switch (state) {
		case 0: return "none";
		case 1: return "uncommitted";
		case 2: return "committed";
		case 3: return "void";
		case 4: return "uncommitted-void";
	}
}
//#endregion
export { stringFromEnum, transaction_state_helper_exports };

//# sourceMappingURL=transaction_state_helper.js.map